var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('VueSignaturePad',{ref:"signaturePad",attrs:{"width":"100%","height":"500px"}}),_c('v-row',[_c('v-btn',{on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t("Guardar")))]),_c('v-btn',{staticClass:"ml-4",on:{"click":_vm.undo}},[_vm._v(_vm._s(_vm.$t("Desfer")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }